import React from 'react';
import { Grid } from '@material-ui/core';
import ReactHtmlParser from 'react-html-parser';
import { isParseValid } from '../../../../../utility/string';
import { convertEditorStateToHTML } from '../../../../../services/editorJS/utils';
import useStyles from '../styles';
import { Article } from '../../../../../types/items';
import ActivityBaseComment from '../ActivityBaseComment';

type Props = {
  article: Article;
};

const ActivityMessageComment = ({ article }: Props) => {
  const classes = useStyles();
  const message = (article.message && isParseValid(article.message)) ? JSON.parse(article.message) : null;
  const name = article.ref.user?.full_name_first_last;

  if (!message) return null;

  return (
    <ActivityBaseComment
      header={(
        <Grid>
          <span className={classes.accent}>{name}</span>
          <span className={classes.timestamp}>{article.ref.created_age}</span>
        </Grid>
      )}
      content={<>{ReactHtmlParser(convertEditorStateToHTML(message))}</>}
    />
  );
};

export default ActivityMessageComment;
